import { apiRequest } from "@/services/api/client";

export type PdfProgressBeaconStage = "mapping" | "generating";

export interface PdfProgressBeaconPayload {
  stage: PdfProgressBeaconStage;
  status_message?: string;
  progress_percentage?: number;
  pending_requests?: number;
}

let activeTaskId: string | null = null;
let lastBeaconAt = 0;
const BEACON_THROTTLE_MS = 750;

/** Remember the background task id for progress beacons on the /pdf route. */
export function setPdfProgressTaskId(taskId: string | null): void {
  activeTaskId = taskId;
}

export function getPdfProgressTaskId(): string | null {
  return activeTaskId;
}

/**
 * Throttled progress beacon from the headless PDF page to the API.
 * Failures are ignored so capture is never blocked.
 */
export async function reportPdfGenerationProgress(
  payload: PdfProgressBeaconPayload,
): Promise<void> {
  if (!activeTaskId || typeof window === "undefined") return;

  const now = Date.now();
  if (now - lastBeaconAt < BEACON_THROTTLE_MS) return;
  lastBeaconAt = now;

  try {
    await apiRequest({
      method: "PATCH",
      url: `/pdf/tasks/${activeTaskId}/progress`,
      data: payload,
    });
  } catch (error) {
    console.debug("[PDF Progress] Beacon failed (non-fatal):", error);
  }
}
